/**
 * Baacal — ring Viewed Product (JHqH2E) and Added to Cart (XfQrqU).
 *
 * Posts Klaviyo Client Events with public site ID when the browser is known:
 * logged-in email, utm_email, Welcome _kx, or an identified __kla_id cookie
 * from a past signup / purchase / form (returning subscriber).
 *
 * ATC writers (one event wins via shared dedupe):
 *   1. theme.dev.js success callback → baacalKlaviyoAddedToCart (normal cart)
 *   2. fetch interceptor on /cart/add(.js)? (quick add / preorder / apps)
 *   3. theme:cart:added → /cart.js key-diff (drawer rebuilt; safety net)
 *
 * Docs: https://help.klaviyo.com/hc/en-us/articles/115005080447
 *       https://help.klaviyo.com/hc/en-us/articles/360034666712
 *
 * Do not invent custom metric names. Never put a private pk_ key here.
 */
(function () {
  var COMPANY_ID = "NQLLkQ";
  var REVISION = "2026-01-15";
  var ENDPOINT =
    "https://a.klaviyo.com/client/events/?company_id=" + COMPANY_ID;
  var ATC_DEDUPE_MS = 2500;

  var lastAtcKey = "";
  var lastAtcAt = 0;
  var lastViewedProductId = "";
  var cartSnapshotKeys = null;
  var cartDiffInflight = false;
  var pending = [];
  var flushAttempts = 0;
  var MAX_FLUSH_ATTEMPTS = 20;
  var PENDING_STORAGE_KEY = "baacal_klaviyo_pending_v1";
  var MAX_PENDING = 20;

  function loadPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_STORAGE_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) {
        pending = parsed.slice(0, MAX_PENDING);
      }
    } catch (e) {}
  }

  function savePending() {
    try {
      if (!pending.length) {
        sessionStorage.removeItem(PENDING_STORAGE_KEY);
        return;
      }
      sessionStorage.setItem(
        PENDING_STORAGE_KEY,
        JSON.stringify(pending.slice(0, MAX_PENDING))
      );
    } catch (e) {}
  }

  function clearPendingStorage() {
    try {
      sessionStorage.removeItem(PENDING_STORAGE_KEY);
    } catch (e) {}
  }

  /** Prefer raw cookie value for base64 (__kla_id); decodeURIComponent can break '+'. */
  function cookieGetRaw(name) {
    try {
      var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return match ? match[1] : "";
    } catch (e) {
      return "";
    }
  }

  function kxFromLocation() {
    var kx = "";
    try {
      kx = new URLSearchParams(window.location.search).get("_kx") || "";
    } catch (e) {}
    if (kx) return kx;
    try {
      var hash = window.location.hash || "";
      if (!hash) return "";
      var q = hash.indexOf("?");
      var body = q >= 0 ? hash.slice(q + 1) : hash.replace(/^#/, "");
      if (body.indexOf("_kx=") === -1 && body.indexOf("%5Fkx=") === -1) {
        // Also support #_kx=TOKEN
        if (hash.indexOf("_kx=") === 0 || hash.indexOf("#_kx=") === 0) {
          body = hash.replace(/^#/, "");
        }
      }
      kx = new URLSearchParams(body).get("_kx") || "";
    } catch (e2) {}
    return kx || "";
  }

  // #region agent log
  function dbg(hypothesisId, location, message, data) {
    var payload = {
      sessionId: "f4bcb8",
          runId: "post-fix",
      hypothesisId: hypothesisId,
      location: location,
      message: message,
      data: data || {},
      timestamp: Date.now(),
    };
    try {
      window.__BAACAL_ATC_DEBUG = window.__BAACAL_ATC_DEBUG || [];
      window.__BAACAL_ATC_DEBUG.push(payload);
      try {
        sessionStorage.setItem(
          "__BAACAL_ATC_DEBUG",
          JSON.stringify(window.__BAACAL_ATC_DEBUG.slice(-40))
        );
      } catch (e0) {}
    } catch (e1) {}
    try {
      fetch("http://127.0.0.1:7843/ingest/cab8e8be-8d37-42d0-a369-e1650b2e51b6", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Debug-Session-Id": "f4bcb8",
        },
        body: JSON.stringify(payload),
      }).catch(function () {});
    } catch (e2) {}
  }
  // #endregion

  function cookieGet(name) {
    try {
      var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return match ? decodeURIComponent(match[1]) : "";
    } catch (e) {
      return "";
    }
  }

  function cookieSet(name, value) {
    try {
      document.cookie =
        name + "=" + encodeURIComponent(value) + ";path=/;max-age=604800;SameSite=Lax";
    } catch (e) {}
  }

  function decodeKlaId() {
    var candidates = [];
    var rawEnc = cookieGetRaw("__kla_id");
    var rawDec = cookieGet("__kla_id");
    if (rawEnc) candidates.push(rawEnc);
    if (rawDec && rawDec !== rawEnc) candidates.push(rawDec);
    for (var i = 0; i < candidates.length; i++) {
      var raw = candidates[i];
      try {
        return JSON.parse(atob(raw));
      } catch (e) {
        try {
          return JSON.parse(decodeURIComponent(escape(atob(raw))));
        } catch (e2) {}
      }
    }
    return null;
  }

  function klaIdentity() {
    var data = decodeKlaId();
    if (!data || typeof data !== "object") {
      // #region agent log
      if (!window.__baacalKlaLogged) {
        window.__baacalKlaLogged = true;
        dbg("F", "baacal-klaviyo-atc-ping.js:klaIdentity", "kla-decode", {
          decodeOk: false,
          rawPresent: !!cookieGet("__kla_id"),
        });
      }
      // #endregion
      return { email: "", kx: "" };
    }
    var email =
      data.$email ||
      data.email ||
      data.$identifier ||
      "";
    var kx =
      data.$exchange_id ||
      data.exchange_id ||
      data.$kx ||
      data.kx ||
      "";
    if (email && typeof email === "string" && email.indexOf("@") === -1) {
      email = "";
    }
    // #region agent log
    if (!window.__baacalKlaLogged) {
      window.__baacalKlaLogged = true;
      var keys = [];
      try {
        keys = Object.keys(data).slice(0, 20);
      } catch (eK) {}
      dbg("F", "baacal-klaviyo-atc-ping.js:klaIdentity", "kla-decode", {
        decodeOk: true,
        klaKeys: keys,
        hasEmailField: !!(data.$email || data.email),
        hasKxField: !!(data.$exchange_id || data.exchange_id || data.$kx || data.kx),
        hasCid: !!data.cid,
        kxType: typeof kx,
        kxLen: kx && typeof kx === "string" ? kx.length : 0,
      });
    }
    // #endregion
    return {
      email: email && typeof email === "string" ? email : "",
      kx: kx && typeof kx === "string" ? kx : "",
    };
  }

  function identity() {
    var email = window.BAACAL_CUSTOMER_EMAIL;
    var emailSrc = email ? "customer" : "";
    var kx = "";
    var kxSrc = "";
    try {
      var params = new URLSearchParams(window.location.search);
      if (!email) {
        email = params.get("utm_email");
        if (email) emailSrc = "utm_email";
      }
      // Persist so later PDP / quick-add / preorder keeps Client Events identity
      // after the landing URL loses utm_email / _kx.
      if (email) cookieSet("baacal_email", email);
      kx = kxFromLocation();
      if (kx) {
        kxSrc = "url";
        cookieSet("baacal_kx", kx);
      }
    } catch (e) {}
    if (!email) {
      email = cookieGet("baacal_email");
      if (email) emailSrc = "cookie";
    }
    if (!kx) {
      kx = cookieGet("baacal_kx");
      if (kx) kxSrc = "cookie";
    }

    var kla = klaIdentity();
    if (!email && kla.email) {
      email = kla.email;
      emailSrc = "kla";
      cookieSet("baacal_email", email);
    }
    if (!kx && kla.kx) {
      kx = kla.kx;
      kxSrc = "kla";
      // Persist exchange id so later navigations keep Client Events identity
      // after __kla_id is pruned or hard to decode.
      cookieSet("baacal_kx", kx);
    }

    // #region agent log
    if (!window.__baacalIdLogged) {
      window.__baacalIdLogged = true;
      dbg("B", "baacal-klaviyo-atc-ping.js:identity", "identity-resolved", {
        hasEmail: !!(email && typeof email === "string"),
        hasKx: !!kx,
        emailSrc: emailSrc || "none",
        kxSrc: kxSrc || "none",
      });
    }
    // #endregion

    return {
      email: email && typeof email === "string" ? email : "",
      kx: kx || "",
    };
  }

  function hasIdentity(id) {
    return !!(id && (id.email || id.kx));
  }

  function identifyNative(id) {
    if (!id.email) return;
    try {
      window.klaviyo = window.klaviyo || [];
      window._learnq = window._learnq || [];
      var payload = { $email: id.email, email: id.email };
      if (typeof window.klaviyo.identify === "function") {
        window.klaviyo.identify(payload);
      } else if (typeof window.klaviyo.push === "function") {
        window.klaviyo.push(["identify", payload]);
      }
      window._learnq.push(["identify", payload]);
    } catch (e) {}
  }

  /**
   * Documented onsite API: klaviyo.isIdentified([callback]) → boolean / Promise.
   * https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object
   */
  function checkKlaviyoIdentified(done) {
    var settled = false;
    function finish(value) {
      if (settled) return;
      settled = true;
      done(!!value);
    }

    try {
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.isIdentified === "function") {
        var result = window.klaviyo.isIdentified(function (identified) {
          finish(identified);
        });
        if (result && typeof result.then === "function") {
          result.then(finish).catch(function () {
            finish(false);
          });
        }
        return;
      }
      if (typeof window.klaviyo.push === "function") {
        window.klaviyo.push([
          "isIdentified",
          function (identified) {
            finish(identified);
          },
        ]);
        setTimeout(function () {
          finish(false);
        }, 1200);
        return;
      }
    } catch (e) {}
    finish(false);
  }

  /**
   * Onsite track uses Klaviyo's __kla_id cookie when isIdentified() is true,
   * even if we cannot decode email/_kx for Client Events. Without this,
   * pending events never flush after hard refresh (flushPending required email/_kx).
   */
  function sendNativeTrack(metricName, properties, value) {
    try {
      window.klaviyo = window.klaviyo || [];
      window._learnq = window._learnq || [];
      var props = {};
      var src = properties || {};
      for (var k in src) {
        if (Object.prototype.hasOwnProperty.call(src, k)) props[k] = src[k];
      }
      if (value != null && props.$value == null) props.$value = value;
      if (typeof window.klaviyo.track === "function") {
        window.klaviyo.track(metricName, props);
      } else if (typeof window.klaviyo.push === "function") {
        window.klaviyo.push(["track", metricName, props]);
      } else {
        return false;
      }
      window._learnq.push(["track", metricName, props]);
      return true;
    } catch (e) {
      return false;
    }
  }

  function sendClientEvent(metricName, properties, value, uniqueId) {
    var id = identity();
    if (!hasIdentity(id)) {
      // #region agent log
      dbg("A", "baacal-klaviyo-atc-ping.js:sendClientEvent", "queued-no-identity", {
        metricName: metricName,
        hasEmail: false,
        hasKx: false,
        pendingLen: pending.length + 1,
        productName: (properties && (properties["Product Name"] || properties.Name)) || "",
      });
      // #endregion
      pending.push({
        metricName: metricName,
        properties: properties,
        value: value,
        uniqueId: uniqueId,
      });
      savePending();
      // Cookie-identified sessions: flush via native track (do not wait for email/_kx).
      flushPending();
      return;
    }
    // #region agent log
    dbg("A", "baacal-klaviyo-atc-ping.js:sendClientEvent", "posting-client-event", {
      metricName: metricName,
      hasEmail: !!id.email,
      hasKx: !!id.kx,
      productName: (properties && (properties["Product Name"] || properties.Name)) || "",
      productId: (properties && properties.ProductID) || "",
    });
    // #endregion
    identifyNative(id);
    // Prefer email when both are present. A stale __kla_id exchange_id can
    // point at a different profile than the known email / utm_email.
    var attrs = {};
    if (id.email) {
      attrs.email = id.email;
    } else if (id.kx) {
      attrs._kx = id.kx;
    }
    var body = {
      data: {
        type: "event",
        attributes: {
          metric: {
            data: {
              type: "metric",
              attributes: { name: metricName },
            },
          },
          profile: {
            data: {
              type: "profile",
              attributes: attrs,
            },
          },
          properties: properties || {},
        },
      },
    };
    if (value != null) body.data.attributes.value = value;
    if (uniqueId) body.data.attributes.unique_id = String(uniqueId);
    fetch(ENDPOINT, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        revision: REVISION,
      },
      body: JSON.stringify(body),
    }).catch(function () {});
  }

  function flushPending() {
    if (!pending.length) loadPending();
    if (!pending.length) return;
    if (hasIdentity(identity())) {
      while (pending.length) {
        var item = pending.shift();
        sendClientEvent(item.metricName, item.properties, item.value, item.uniqueId);
      }
      clearPendingStorage();
      return;
    }
    // No email/_kx in our identity helpers, but Klaviyo may still know this browser.
    checkKlaviyoIdentified(function (identified) {
      if (!identified || !pending.length) {
        // #region agent log
        if (!window.__baacalFlushLogged) {
          window.__baacalFlushLogged = true;
          dbg("A", "baacal-klaviyo-atc-ping.js:flushPending", "cannot-flush", {
            identified: !!identified,
            pendingLen: pending.length,
          });
        }
        // #endregion
        savePending();
        return;
      }
      while (pending.length) {
        var item = pending.shift();
        var ok = sendNativeTrack(item.metricName, item.properties, item.value);
        // #region agent log
        dbg("A", "baacal-klaviyo-atc-ping.js:flushPending", "flushed-native", {
          metricName: item.metricName,
          ok: ok,
          productName:
            (item.properties &&
              (item.properties["Product Name"] || item.properties.Name)) ||
            "",
        });
        // #endregion
      }
      clearPendingStorage();
    });
  }

  function viewedProductProperties(p) {
    var props = {
      Name: p.Name,
      ProductID: String(p.ProductID || ""),
      URL: p.URL,
      ImageURL: p.ImageURL,
      Price: p.Price,
      Brand: p.Brand,
    };
    if (p.CompareAtPrice != null && p.CompareAtPrice !== "") {
      props.CompareAtPrice = p.CompareAtPrice;
    }
    if (p.Categories && p.Categories.length) {
      props.Categories = p.Categories;
    }
    return props;
  }

  function pingViewedProduct() {
    var p = window.BAACAL_VIEWED_PRODUCT;
    if (!p || !p.Name) return;
    var productId = String(p.ProductID || p.Name || "");
    if (!productId || productId === lastViewedProductId) return;
    lastViewedProductId = productId;
    sendClientEvent(
      "Viewed Product",
      viewedProductProperties(p),
      p.Price,
      "baacal-vp-" + productId + "-" + Date.now()
    );
  }

  function moneyToNumber(value) {
    if (typeof value === "number" && !isNaN(value)) {
      return value > 5000 ? value / 100 : value;
    }
    if (typeof value === "string") {
      var n = parseFloat(value.replace(/[^0-9.]/g, ""));
      return isNaN(n) ? undefined : n;
    }
    return undefined;
  }

  function productUrl(item) {
    var path = item.url || (item.handle && "/products/" + item.handle);
    if (!path) return "https://www.baacal.com/cart";
    if (/^https?:/i.test(path)) {
      return path.replace("baacal-clothing.myshopify.com", "www.baacal.com");
    }
    return "https://www.baacal.com" + (path.charAt(0) === "/" ? path : "/" + path);
  }

  function imageUrl(item) {
    var img = item.image || item.featured_image || "";
    if (!img) return undefined;
    if (typeof img === "object") img = img.url || img.src || "";
    if (!img) return undefined;
    if (img.indexOf("//") === 0) return "https:" + img;
    return img;
  }

  /** Shopify error payloads use numeric status (422). Ignore other status fields. */
  function isCartAddError(payload) {
    if (!payload || typeof payload !== "object") return true;
    if (typeof payload.status === "number" && payload.status >= 400) return true;
    if (payload.message && !payload.variant_id && !payload.product_id && !payload.items) {
      return true;
    }
    return false;
  }

  function normalizeCartAddItems(payload) {
    if (!payload || typeof payload !== "object") return [];
    if (isCartAddError(payload)) return [];
    if (Array.isArray(payload.items) && payload.items.length) {
      return payload.items.filter(function (row) {
        return row && (row.variant_id || row.product_id || row.key);
      });
    }
    if (payload.variant_id || payload.product_id || payload.key) {
      return [payload];
    }
    return [];
  }

  function claimAtcDedupe(item, qtyOverride) {
    var qty = qtyOverride != null ? qtyOverride : item.quantity || 1;
    var key =
      String(item.key || item.variant_id || item.product_id || item.title || "") +
      ":" +
      String(qty);
    var now = Date.now();
    if (key === lastAtcKey && now - lastAtcAt < ATC_DEDUPE_MS) return false;
    lastAtcKey = key;
    lastAtcAt = now;
    return true;
  }

  function pingAddedToCartItem(item, qtyOverride) {
    if (!item) return;
    var qty = qtyOverride != null ? qtyOverride : item.quantity || 1;
    if (!claimAtcDedupe(item, qty)) {
      // #region agent log
      dbg("D", "baacal-klaviyo-atc-ping.js:pingAddedToCartItem", "dedupe-blocked", {
        variantId: String(item.variant_id || ""),
        key: String(item.key || ""),
        qty: qty,
        title: item.product_title || item.title || "",
      });
      // #endregion
      return;
    }
    // #region agent log
    dbg("D", "baacal-klaviyo-atc-ping.js:pingAddedToCartItem", "ping-atc", {
      variantId: String(item.variant_id || ""),
      key: String(item.key || ""),
      qty: qty,
      title: item.product_title || item.title || "",
    });
    // #endregion
    var price = moneyToNumber(item.final_price != null ? item.final_price : item.price);
    var compareAt = moneyToNumber(
      item.original_price != null
        ? item.original_price
        : item.compare_at_price != null
          ? item.compare_at_price
          : undefined
    );
    var props = {
      "Product Name": item.product_title || item.title,
      ProductID: String(item.product_id || ""),
      URL: productUrl(item),
      Quantity: qty,
    };
    if (item.variant_id) props.VariantID = String(item.variant_id);
    var variantName = item.variant_title;
    if (!variantName || variantName === "Default Title") {
      // Fallback: size/color from options when title is empty/default
      if (item.options && item.options.length) {
        variantName = item.options.filter(Boolean).join(" / ");
      } else if (item.variant_options && item.variant_options.length) {
        variantName = item.variant_options.filter(Boolean).join(" / ");
      }
    }
    if (variantName && variantName !== "Default Title") {
      props["Variant Name"] = variantName;
    }
    if (item.sku) props["Variant SKU"] = item.sku;
    if (item.product_type) props["Product Type"] = item.product_type;
    if (item.vendor) props.Brand = item.vendor;
    if (price != null) props.Price = price;
    if (compareAt != null && compareAt > 0) props.CompareAtPrice = compareAt;
    var img = imageUrl(item);
    if (img) props.ImageURL = img;
    sendClientEvent(
      "Added to Cart",
      props,
      price,
      "baacal-atc-" + (item.key || item.variant_id || item.product_id || Date.now()) + "-" + Date.now()
    );
  }

  window.baacalKlaviyoAddedToCart = function (payload) {
    var items = normalizeCartAddItems(payload);
    // #region agent log
    dbg("B", "baacal-klaviyo-atc-ping.js:baacalKlaviyoAddedToCart", "callback-payload", {
      hasPayload: !!payload,
      payloadType: payload ? typeof payload : "null",
      statusType: payload ? typeof payload.status : "n/a",
      statusVal: payload && typeof payload.status === "number" ? payload.status : null,
      hasItemsArr: !!(payload && payload.items && payload.items.length),
      hasVariant: !!(payload && payload.variant_id),
      hasProduct: !!(payload && payload.product_id),
      normalizedCount: items.length,
      firstTitle: items[0]
        ? items[0].product_title || items[0].title || ""
        : "",
    });
    // #endregion
    if (!items.length) {
      // Non-JSON / odd success shape: fall through to cart.js diff shortly.
      scheduleCartDiff(150);
      return;
    }
    for (var i = 0; i < items.length; i++) {
      pingAddedToCartItem(items[i]);
    }
  };

  function itemKeyMap(cart) {
    var map = {};
    var lines = (cart && cart.items) || [];
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!line) continue;
      var k = String(line.key || line.variant_id || "");
      if (!k) continue;
      map[k] = line;
    }
    return map;
  }

  function snapshotCartKeys(done) {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        cartSnapshotKeys = itemKeyMap(cart);
        if (typeof done === "function") done(cart);
      })
      .catch(function () {
        if (!cartSnapshotKeys) cartSnapshotKeys = {};
        if (typeof done === "function") done(null);
      });
  }

  function diffAndPingCart(prevMap) {
    if (cartDiffInflight) {
      // #region agent log
      dbg("C", "baacal-klaviyo-atc-ping.js:diffAndPingCart", "skipped-inflight", {});
      // #endregion
      return;
    }
    cartDiffInflight = true;
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var nextMap = itemKeyMap(cart);
        var before = prevMap || cartSnapshotKeys || {};
        var newKeys = [];
        var bumped = [];
        Object.keys(nextMap).forEach(function (key) {
          var next = nextMap[key];
          var prev = before[key];
          if (!prev) {
            newKeys.push(next.product_title || next.title || key);
            pingAddedToCartItem(next, next.quantity || 1);
            return;
          }
          var prevQty = prev.quantity || 0;
          var nextQty = next.quantity || 0;
          if (nextQty > prevQty) {
            bumped.push(next.product_title || next.title || key);
            pingAddedToCartItem(next, nextQty - prevQty);
          }
        });
        // #region agent log
        dbg("C", "baacal-klaviyo-atc-ping.js:diffAndPingCart", "cart-diff-result", {
          beforeCount: Object.keys(before).length,
          afterCount: Object.keys(nextMap).length,
          newKeys: newKeys,
          bumped: bumped,
        });
        // #endregion
        cartSnapshotKeys = nextMap;
      })
      .catch(function () {})
      .then(function () {
        cartDiffInflight = false;
      });
  }

  function scheduleCartDiff(delayMs) {
    var before = cartSnapshotKeys ? Object.assign({}, cartSnapshotKeys) : null;
    setTimeout(function () {
      if (!before) {
        // #region agent log
        dbg("C", "baacal-klaviyo-atc-ping.js:scheduleCartDiff", "no-before-snapshot", {
          delayMs: delayMs || 200,
        });
        // #endregion
        snapshotCartKeys(function () {
          // Snapshot taken after add; cannot diff this cycle. Next add will work.
        });
        return;
      }
      diffAndPingCart(before);
    }, delayMs || 200);
  }

  if (window.fetch && !window.__baacalCartFetchHooked) {
    window.__baacalCartFetchHooked = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var method = (
        (init && init.method) ||
        (typeof Request !== "undefined" && input instanceof Request && input.method) ||
        "GET"
      ).toUpperCase();
      var isCartAdd =
        method === "POST" && /\/cart\/add(\.js)?(\?|$)/.test(String(url));
      // Freeze keys before the add so theme:cart:added can key-diff if JSON misses.
      var keysBeforeAdd = null;
      if (isCartAdd) {
        keysBeforeAdd = cartSnapshotKeys
          ? Object.assign({}, cartSnapshotKeys)
          : null;
        if (!cartSnapshotKeys) snapshotCartKeys();
      }
      var pendingFetch = origFetch.apply(this, arguments);
      if (isCartAdd) {
        // #region agent log
        dbg("C", "baacal-klaviyo-atc-ping.js:fetch", "cart-add-intercepted", {
          url: String(url).slice(0, 120),
          hadSnapshot: !!keysBeforeAdd,
        });
        // #endregion
        pendingFetch
          .then(function (res) {
            return res
              .clone()
              .json()
              .then(function (body) {
                if (typeof window.baacalKlaviyoAddedToCart === "function") {
                  window.baacalKlaviyoAddedToCart(body);
                }
              })
              .catch(function () {
                // #region agent log
                dbg("B", "baacal-klaviyo-atc-ping.js:fetch", "cart-add-json-failed", {
                  url: String(url).slice(0, 120),
                });
                // #endregion
                if (keysBeforeAdd) cartSnapshotKeys = keysBeforeAdd;
                scheduleCartDiff(250);
              });
          })
          .catch(function () {
            if (keysBeforeAdd) cartSnapshotKeys = keysBeforeAdd;
            scheduleCartDiff(250);
          });
      }
      return pendingFetch;
    };
  }

  // Past-tense: fires after drawer rebuild. Covers quick buy + preorder paths
  // that rebuild the cart without a clean JSON body through our writers.
  document.addEventListener("theme:cart:added", function () {
    // #region agent log
    dbg("C", "baacal-klaviyo-atc-ping.js:theme:cart:added", "drawer-rebuilt", {
      hasSnapshot: !!cartSnapshotKeys,
      snapshotCount: cartSnapshotKeys ? Object.keys(cartSnapshotKeys).length : 0,
    });
    // #endregion
    scheduleCartDiff(50);
  });

  // Pre-seed cart keys so the first add can key-diff if JSON writers miss.
  snapshotCartKeys();
  loadPending();

  function applyIdentifyPayload(data) {
    if (!data || typeof data !== "object") return;
    if (data.email) cookieSet("baacal_email", data.email);
    if (data.kx) cookieSet("baacal_kx", data.kx);
    window.__baacalIdLogged = false;
    flushPending();
  }

  // Late identity from Liquid identify-publish (login / _kx / utm_email).
  try {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.subscribe === "function"
    ) {
      Shopify.analytics.subscribe("baacal_klaviyo_identify", function (event) {
        var data =
          (event && (event.customData || event.data || event)) || {};
        applyIdentifyPayload(data);
      });
    }
  } catch (eSub) {}

  function scheduleFlush() {
    flushPending();
    if (!pending.length) return;
    flushAttempts += 1;
    if (flushAttempts >= MAX_FLUSH_ATTEMPTS) return;
    checkKlaviyoIdentified(function (identified) {
      if (identified || hasIdentity(identity())) {
        flushPending();
      }
      if (pending.length && flushAttempts < MAX_FLUSH_ATTEMPTS) {
        setTimeout(scheduleFlush, 500);
      }
    });
  }

  // #region agent log
  (function bootUrlProbe() {
    try {
      var params = new URLSearchParams(window.location.search);
      var keys = [];
      params.forEach(function (_v, k) {
        keys.push(k);
      });
      var ref = "";
      try {
        ref = document.referrer ? new URL(document.referrer).host : "";
      } catch (eR) {
        ref = "bad";
      }
      dbg("E", "baacal-klaviyo-atc-ping.js:boot", "boot-url", {
        host: window.location.host,
        path: window.location.pathname.slice(0, 80),
        paramKeys: keys,
        hasKxParam: params.has("_kx"),
        hasHashKx: (window.location.hash || "").indexOf("_kx") !== -1,
        referrerHost: ref,
        cookieKx: !!cookieGet("baacal_kx"),
        cookieEmail: !!cookieGet("baacal_email"),
        klaRaw: !!cookieGet("__kla_id"),
      });
    } catch (eBoot) {}
  })();
  // #endregion

  pingViewedProduct();
  // Re-check after paint / bfcache restore / late Liquid identity. New ProductID
  // only — never once-per-session. Fixes "VP stopped after Marion".
  window.addEventListener("pageshow", function () {
    pingViewedProduct();
  });
  setTimeout(pingViewedProduct, 400);
  setTimeout(pingViewedProduct, 1200);
  setTimeout(pingViewedProduct, 3000);

  flushPending();
  setTimeout(scheduleFlush, 500);
  setTimeout(scheduleFlush, 1500);
  setTimeout(scheduleFlush, 4000);
})();
